import React from 'react';

const Skeleton = ({ circle, width, height, marginBottom, className = '', }) => {
    const style = {};
    if (typeof width !== 'undefined') {
        style.width = width;
    }
    if (typeof height !== 'undefined') {
        style.height = height;
    }
    if (typeof marginBottom !== 'undefined') {
        style.marginBottom = marginBottom;
    }
    return (React.createElement("div", { style: style, className: `base-skeleton ${circle ? 'circle' : 'text'} ${className}` }));
};

export { Skeleton as S };
//# sourceMappingURL=Skeleton-RKr5mJai.js.map
